export enum SecondFactorState {
  init,
  failed,
  enforced,
}
